@<template>
  <div>
    <div class="study">
      <div class="study-play">
        <div class="study-Location">
          <StudyAndStudy></StudyAndStudy>
        </div>
      </div>
    </div>

    <div class="this-Part">
      <div class="this-Part-Play">
        <div class="this-Part-Text">
          <p @click="flashData" style="cursor:pointer">&#10148;  {{ $route.query.architecture_name }}</p>
          <Button type="primary" style="margin-top: -20px;float: right" @click="returnPrevious">{{$t('i.login.returnPrevious')}}</Button>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import StudyAndStudy from "../../../common/components/StudyAndStudy";
  export default {
    name: "training",
    components: {StudyAndStudy},
    data(){
      return{

      }
    },
    methods: {
      async flashData(){
        this.$emit('flashData')
      },
      returnPrevious(){
        this.$router.go(-1);
        // this.$router.back(-1)
      }
    }
  }
</script>

<style scoped>
  .study{
    width: 100%;
    height: 33px;
    margin-top: 35px;
  }

  .study-play{
    width: 1320px;
    height: 30px;
    margin: 0 auto;
  }

  .study-Location{
    position: relative;
  }
  .this-Part{
    width: 100%;
    height: 90px;
  }

  .this-Part-Play{
    width: 1050px;
    height: 90px;
    margin: 0 auto;
    padding-top: 1px;
  }

  .this-Part-Text{
    margin-top: 25px;
  }

  .this-Part-Text p{
    font-size: 20px;
  }

  .line{
    width: 1049px;
    height: 1px;
    background-color: #c7c7c7;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/study/components/training.vue